import {EntityApiService, ApiClientService} from '@dofleini/security';

class ClientsAreaApiService extends EntityApiService {

    getOneArea = ({areaId}) => ApiClientService.get(this.getPath(`/${areaId}`));

    searchSpace = (params) => ApiClientService.post(this.getPath('/search-space'), params);
}

export default new ClientsAreaApiService('/ms-core/api/areas');
